module.exports = {
  title: '商品保价',
  route: {
    path: '/logistics',
    children: {
      path: 'logistics-insured-price',
    },
  },
};
